<template>
  <section id="main">
    <div class="container">
      <div class="row gtr-200">
        <div class="col-12 about-us">
          <section class="box highlight">
            <v-gallery :images="list" :caption="true"/>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'KnowUs',
  data () {
    return {
      list: [
        { title: 'Talleres', url: require('../assets/images/gallery/img1.jpg') },
        { title: 'Talleres', url: require('../assets/images/gallery/img3.jpg') },
        { title: 'Talleres', url: require('../assets/images/gallery/img4.jpg') },
        { title: 'Talleres', url: require('../assets/images/gallery/img5.jpg') },
        { title: 'Talleres', url: require('../assets/images/gallery/img6.jpg') },
        { title: 'Talleres', url: require('../assets/images/gallery/img7.jpg') },
        { title: 'Talleres', url: require('../assets/images/gallery/img8.jpg') },
        { title: 'Talleres', url: require('../assets/images/gallery/img9.jpg') },
        { title: 'Talleres', url: require('../assets/images/gallery/img10.jpg') },
        { title: 'Talleres', url: require('../assets/images/gallery/img11.jpg') },
        { title: 'Talleres', url: require('../assets/images/gallery/img12.jpg') },
        { title: 'Talleres', url: require('../assets/images/gallery/img13.jpg') },
        { title: 'Talleres', url: require('../assets/images/gallery/img14.jpg') },
        { title: 'Talleres', url: require('../assets/images/gallery/img15.jpg') },
        { title: 'Talleres', url: require('../assets/images/gallery/img16.jpg') },
        { title: 'Talleres', url: require('../assets/images/gallery/img17.jpg') }
      ]
    }
  }
}
</script>
